import { EEGPage } from "./EEGPage";
import { TimeSeriesPageManager } from "./TimeSeriesPageManager";

export class EEGTimeSeriesPageManager extends TimeSeriesPageManager<EEGPage> {
	getPageMaker(): () => EEGPage {
		return (): EEGPage => new EEGPage(this)
	}
}
